<div class="bathroom-range-selector" [class.embedded]="embedded" [class.desktop]="layoutMode === 'desktop'">
  @if (!isLoading) {
  @if (!embedded) {
    <div class="header">
      <button class="back-button" (click)="goBack()">
        <fa-icon [icon]="faArrowLeft"></fa-icon>
        <span>{{ 'common.back' | translate }}</span>
      </button>
    </div>
  }

  <div class="content">
    <h1 class="title">
      {{ 'configuration.mobile.bathroom.all-the' | translate }}
      <span class="blue">{{ 'configuration.mobile.bathroom.collections' | translate }}</span>
    </h1>

    <div class="ranges-grid">
      <div class="range-card" *ngFor="let range of availableRanges" (click)="selectRange(range)">
        <div class="range-image-container">
          <img [src]="range.imagePath" [alt]="range.name" />
          <div class="range-overlay">
            <span class="range-name">{{ range.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  } @else {
  <div class="loading-container">
    <div class="spinner"></div>
    <p [innerHTML]="'configuration.mobile.bathroom.loading_ranges' | translate"></p>
  </div>
  }
</div>
